import { createContext, useContext } from 'react';
import { getTestIdProps } from '../HBBanner/utils';

const ModalContext = createContext<{ testId: string; testIdName: string }>(
    null
);

export const ModalInternalProvider = ModalContext.Provider;

export const useModalInternalContext = () => {
    const props = useContext(ModalContext);

    return {
        ...props,
        getTestIdProps: (suffix: string) => getTestIdProps({ ...props, suffix })
    };
};
